import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { SkeletonContainer } from './styles';

const Index = () => {
  return (
    <SkeletonContainer>
      <Skeleton height={'24px'} borderRadius={'8px'} />
      <br />
      <Skeleton height={'20px'} borderRadius={'8px'} />
      <br />
      <Skeleton height={'48px'} borderRadius={'8px'} />
      <br />
      <br />
      <Skeleton height={'32px'} borderRadius={'8px'} />
      <br />
      <Skeleton height={'140px'} borderRadius={'8px'} />
      <br />
      <Skeleton height={'140px'} borderRadius={'8px'} />
      <br />
      <Skeleton height={'140px'} borderRadius={'8px'} />
    </SkeletonContainer>
  );
};

export default Index;
